"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.removeToken = removeToken;
exports.setToken = setToken;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _portalStorage = require("@/utils/portalStorage");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function getToken() {
  return _jsCookie.default.get(_portalStorage.TOKEN_COOKIE_KEY);
}
function setToken(token) {
  return _jsCookie.default.set(_portalStorage.TOKEN_COOKIE_KEY, token);
}
function removeToken() {
  return _jsCookie.default.remove(_portalStorage.TOKEN_COOKIE_KEY);
}